import { render, staticRenderFns } from "./LTooltip.vue?vue&type=template&id=e2244f74&scoped=true"
import script from "./LTooltip.vue?vue&type=script&lang=js"
export * from "./LTooltip.vue?vue&type=script&lang=js"
import style0 from "./LTooltip.vue?vue&type=style&index=0&id=e2244f74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2244f74",
  null
  
)

export default component.exports